export type Route = { kind: "location"; id: string } | { kind: "shop"; id: string };

/** Deep links: `#/location/<id>` jumps straight there, `#/shop/<id>` walks to the shop. */
export function parseHash(hash: string): Route | undefined {
  const m = /^#\/(location|shop)\/([a-z0-9-]+)\/?$/.exec(hash);
  if (!m) return undefined;
  return { kind: m[1] as Route["kind"], id: m[2] as string };
}

export function formatHash(route: Route): string {
  return `#/${route.kind}/${route.id}`;
}
